module.exports = __webpack_public_path__ + "static/media/full.db1f55c7.svg";